import BreadcrumbPedidos from "./BreadcrumbPedidos";
import { Form } from "react-bootstrap";
import { Col, Row, Button, InputGroup, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getPedidos, deletePedido } from "../../services/PedidosService";
import MaoTable from "../common/MaoTable";
import { useNavigate } from "react-router-dom";
import { getFechaHoy, getFechaInicioMes } from "../../utils/DateUtils";
import { formatNumber } from "../../utils/NumberUtils";
import { Cargando } from "../common/Cargando";
import { FaFilePdf } from "react-icons/fa6";
import { validUuid } from "../../utils/UuidUtils";

const api_pdf = process.env.REACT_APP_HOME_URL+"/pedidos/pdf/";

export default function Pedidos() {
    /*
    Links ->
        https://react-bootstrap.netlify.app/
        https://react-bootstrap.netlify.app/docs/getting-started/introduction/
        https://react-bootstrap.netlify.app/docs/components/breadcrumb
        https://react-bootstrap.netlify.app/docs/forms/overview
        https://react-bootstrap.netlify.app/docs/forms/layout
        https://react-bootstrap.netlify.app/docs/forms/input-group

        https://www.npmjs.com/package/react-icons
     */
    
    const [fechaDesde, setFechaDesde] = useState(getFechaInicioMes());
    const [fechaHasta, setFechaHasta] = useState(getFechaHoy());
    const [estado, setEstado] = useState("");
    const [pedidos, setPedidos] = useState([]);
    const [error, setError] = useState("");
    const [cargando, setCargando] = useState(false);

    useEffect(() => {
        buscar();
    }, [])

    async function buscar() {
        let fechaDesdeP = fechaDesde;
        let fechaHastaP = fechaHasta;
        let esatdoP = estado;
        if (fechaDesdeP === undefined || fechaDesdeP==="") {
            setError("");
            setPedidos([]);
            alert("Debe indicar una fecha desde");
        } else {
            setCargando(true);
            let resp = await getPedidos(fechaDesdeP, fechaHastaP, esatdoP);
            setCargando(false);
            if (resp.error) {
                setError(resp.message);
                setPedidos([]);
            } else {
                setError("");
                setPedidos(resp.data);
            }
        }
    }

    const navigate = useNavigate();

    function nuevo() {
        navigate("/pedidos/nuevo?consulta=true");
    }

    function descargar(uuid) {
        if (validUuid(uuid)) {
            window.open(api_pdf+uuid, '_blank'); 
        } else {
            alert("El pdf del pedido no está disponible");
        }
    }

    async function editar(id) {
        navigate("/pedidos/"+id+"?consulta=true");
    }

    async function borrar(id) {
        if (window.confirm("¿Esta seguro que quiere borrar el pedido?")) {
            setCargando(true);
            const resp = await deletePedido(id);
            setCargando(false);
            if (resp.error) {
                alert(resp.message);
            } else {
                alert("Pedido borrado correctamente");
                buscar();
            }
        }
    }

    const columnas = [
        {
            titulo:"Número",
            atributo:"numero",
            className:"text-truncate"
        },{
            titulo:"Fecha",
            atributo:"fecha"
        },{
            titulo:"Marca",
            atributo:"marca",
            className:"d-none d-md-table-cell text-truncate max-width-20-em"
        },{
            titulo:"Cliente",
            atributo:"cliente",
            className:"text-truncate max-width-20-em"
        },{
            titulo:"Total",
            atributo:"total",
            className:"col-importe",
            funcion: formatNumber
        },{
            titulo:"Comisión",
            atributo:"comision",
            className:"d-none d-md-table-cell col-importe",
            funcion: formatNumber
        },{
            titulo:"Estado",
            atributo:"estado"
        }
    ]

    return <>
        <BreadcrumbPedidos active="Pedidos - Consulta"/>
        <Form>
            <Row className="align-items-center">
                <Col xs="auto" md="3">
                    <InputGroup className="mb-2">
                    <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Desde</InputGroup.Text>
                    <Form.Control
                        id="txtFechaDesde" 
                        type="date"
                        value={fechaDesde} onChange={(e) => {setFechaDesde(e.target.value)}}
                        placeholder="Fecha desde..."
                    />
                    </InputGroup>
                </Col>
                <Col xs="auto" md="3">
                    <InputGroup className="mb-2">
                    <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Hasta</InputGroup.Text>
                    <Form.Control
                        id="txtFechaHasta" 
                        type="date"
                        value={fechaHasta} onChange={(e) => {setFechaHasta(e.target.value)}}
                        placeholder="Fecha hasta..."
                    />
                    </InputGroup>
                </Col>
                <Col xs="auto" md="3">
                    <InputGroup className="mb-2">
                    <InputGroup.Text className="btn btn-secondary" style={{width: 5+'em'}}>Estado</InputGroup.Text>
                    <Form.Select id="selEstado" 
                        value={estado} onChange={(e) => {setEstado(e.target.value)}}>
                        <option value="">Todos</option>
                        <option value="P">Pendientes</option>
                        <option value="F">Finalizados</option>
                    </Form.Select>
                    </InputGroup>
                </Col>
                <Col xs="auto">
                    <InputGroup className="mb-2">
                    <Button id="btnBuscar" onClick={() => buscar()}>
                        Buscar
                    </Button>
                    </InputGroup>
                </Col>
            </Row>
            {error!==''?
                <Row>
                    <Col xs="auto">
                        <Alert variant="danger" key="danger">{error}</Alert>
                    </Col>
                </Row>:
                <></>
            }
        </Form>
        {cargando?<Cargando></Cargando>:<></>}
        <MaoTable 
            columnas={columnas} 
            datos={pedidos} 
            colId="pedido_id"
            colEstado="estado"
            colNombre="numero"
            valueEstadoInactivo="P"
            getEstado={(estado) => {return (estado==='F'?'Finalizado':'Pendiente')}}
            borrar={borrar} editar={editar}
            otrasAcciones={[
                {title:"PDF de Pedido", icon:<FaFilePdf />, click: descargar, colId:"pedido_uuid"},
            ]}>
        </MaoTable>
        <Row>
            <Col xs="auto">
                <Button id="btnNuevo" onClick={nuevo}>Nuevo</Button>
            </Col>
        </Row>
    </>
        
}